import { render, staticRenderFns } from "./orderRule.vue?vue&type=template&id=4d40fe34&scoped=true"
import script from "./orderRule.vue?vue&type=script&lang=js"
export * from "./orderRule.vue?vue&type=script&lang=js"
import style0 from "./orderRule.vue?vue&type=style&index=0&id=4d40fe34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d40fe34",
  null
  
)

export default component.exports